import { queryClient } from './queryClient';
import { useOrgStore } from '@/stores/orgStore';
import { useRorosStore } from '@/stores/rorosStore';
import { useNotificationStore } from '@/stores/notificationStore';

/**
 * Wipe every piece of user-scoped client-side state.
 *
 * Called on logout, on login (defense in depth for crashed/failed logouts),
 * and in the session bootstrap drift guard when the fetched user id differs
 * from the stored one (multi-tab case).
 *
 * Everything cleared here is either:
 *   - in-memory only (queryClient, store in-memory state), or
 *   - a localStorage key that belongs to a specific user's session.
 *
 * Things NOT cleared: locale preference, theme preference, auth cookies
 * (those are cleared server-side by /api/auth/logout).
 */
export function resetSessionScopedState(): void {
  useOrgStore.getState().reset();
  useRorosStore.getState().reset();
  useNotificationStore.getState().clearAll();
  queryClient.clear();
}
